import { Box, Grid, Typography } from "@mui/material";
import CancellationMessage from "./cancellationMessage";
import RenderAppointmentOperation from "./renderAppointmentOperation";
import { Appointment } from "../../../../context/appContext";
import { lightTheme } from "../../../../theme/themes/lightTheme";
import React from "react";

const getBackgroundColor = (status: string): string => {
  switch (status) {
    case "K":
      return lightTheme.palette.warning.light;
    case "V":
      return lightTheme.palette.error.light;
    default:
      return "#eeeeee";
  }
};

const BookedAppointmentTile = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => {
  return (
    <Box
      sx={{
        backgroundColor: getBackgroundColor(appointment.status),
        p: 2,
        mb: 2,
        borderRadius: 2,
      }}
    >
      <Grid
        container
        spacing={4}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid item xs={6} sm={4} md>
          <Box>
            <Typography variant="caption" component="div">
              Datum:
            </Typography>
            <Typography variant="body1" component="div">
              {appointment.date.split("-").reverse().join(".")}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} sm={4} md>
          <Box>
            <Typography variant="caption" component="div">
              Uhrzeit:
            </Typography>
            <Typography variant="body1" component="div">
              {appointment.start.slice(0, -3)} bis{" "}
              {appointment.end.slice(0, -3)} Uhr
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} sm={4} md>
          <Box>
            <Typography variant="caption" component="div">
              Typ:
            </Typography>
            <Typography variant="body1" component="div">
              {appointment.type}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} sm={6} md>
          <Box>
            <Typography variant="caption" component="div">
              Coach:
            </Typography>
            <Typography variant="body1" component="div">
              {appointment.coach}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md>
          <RenderAppointmentOperation appointment={appointment} />
        </Grid>

        {/* Renders the cancellation message if the appointment is today. */}
        {appointment.meta.today && !appointment.meta.past && (
          <Grid item xs={12}>
            <CancellationMessage />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default BookedAppointmentTile;
